import React, { FC } from 'react';
import styled from 'styled-components';
import { InfoVideoBox } from 'components/InfoVideoBox/InfoVideoBox';
import { translate, translationKeys } from 'logic/translations/translations.service';

const StyledSection = styled.section`
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const OnlineTutorSchoolDetailSectionPromotion: FC = () => {

  const infoVideoBoxText = {
    headline: translate(translationKeys.infoVideoBox.onlineTutoringPromotionSchoolDetailsPage.headline),
    subheadline: translate(translationKeys.infoVideoBox.onlineTutoringPromotionSchoolDetailsPage.subheadline),
    infoText: translate(translationKeys.infoVideoBox.onlineTutoringPromotionSchoolDetailsPage.infoText),
    buttonText: translate(translationKeys.infoVideoBox.onlineTutoringPromotionSchoolDetailsPage.buttonText),
  };

  return (
    <StyledSection>
      <InfoVideoBox videoID={'545088293'} text={infoVideoBoxText}/>
    </StyledSection>
  );
};
